import { EMPTY_VALUE } from '@/hooks/useBusinessHours';
import timezoneService from '@/services/timezone.service';
import { IWeekly } from '@/types/BusinessHours';
import IBookingRules from '@/types/IBookingRules';
import IServerRepeatingAvailability from '@/types/IServerRepeatingAvailability';
import ITimeZone from '@/types/ITimeZone';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

interface ISectionScheduleProps {
	bookingRules: IBookingRules;
	onChange: (value: { repeatingAvailability: IServerRepeatingAvailability | null }) => void;
}
export default function useSectionSchedule(props: ISectionScheduleProps) {
	const isFetching = useIsFetching() > 0;
	const isMutating = useIsMutating() > 0;
	const { t } = useTranslation();

	function handleWeeklyChange(weekly: IWeekly) {
		props.onChange({
			repeatingAvailability: {
				timeZone: props.bookingRules.repeatingAvailability?.timeZone || timezoneService.getTimeZone(),
				weekly,
			},
		});
	}

	function handleCreateCustomScheduleClick() {
		props.onChange({ repeatingAvailability: { timeZone: timezoneService.getTimeZone(), weekly: EMPTY_VALUE } });
	}

	function handleAlwaysOpenClick() {
		props.onChange({ repeatingAvailability: null });
	}

	function handleTimeZoneChange(value: ITimeZone) {
		// FIXME: Esto ha petado alguna vez en produccion porque repeatingAvailability no estaba definido.
		if (props.bookingRules.repeatingAvailability?.weekly) {
			props.onChange({
				repeatingAvailability: { timeZone: value, weekly: props.bookingRules.repeatingAvailability.weekly },
			});
		}
	}

	function checkEmpty(weeklySchedule: IWeekly | null): boolean {
		if (weeklySchedule === null) {
			return false;
		}
		return Object.values(weeklySchedule).every((daySchedule) => daySchedule.length === 0);
	}

	return {
		handleTimeZoneChange,
		handleAlwaysOpenClick,
		handleCreateCustomScheduleClick,
		handleWeeklyChange,
		isLoading: isFetching || isMutating,
		t,
		timeZone: props.bookingRules.repeatingAvailability?.timeZone,
		weekly: props.bookingRules.repeatingAvailability?.weekly ?? null,
		isEmpty: checkEmpty(props.bookingRules.repeatingAvailability?.weekly ?? null),
	};
}
